"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";

import { css, cva } from "@/../styled-system/css";

const popover = cva({
  base: {
    zIndex: 50,
    w: "300px",
    rounded: "md",
    borderWidth: "1px",
    borderColor: "gray.200",
    backgroundColor: "white",
    p: "4",
    color: "popover.foreground",
    boxShadow: "md",
    outline: "none",

    "&[data-state=open]": {
      animateIn: true,
      fadeIn: 0,
      zoomIn: 95,
    },

    "&[data-state=closed]": {
      animateOut: true,
      fadeOut: 0,
      zoomOut: 95,
    },

    "&[data-side=top]": {
      slideInFromBottom: "2",
    },

    "&[data-side=bottom]": {
      slideInFromTop: "2",
    },

    "&[data-side=left]": {
      slideInFromRight: "2",
    },

    "&[data-side=right]": {
      slideInFromLeft: "2",
    },
  },
});

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    css?: object;
  }
>(({ css: cssProp = {}, align = "center", sideOffset = 4, ...props }, ref) => {
  const className = css(popover.raw(), cssProp);
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={className}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverContent, PopoverTrigger };
